import React from "react";

import classnames from "classnames";

export default function SettingsDrawerButton(props: {
	setIsOpen: (flag: boolean) => void;
	isOpen: boolean;
	buttonClasses?: string;
	iconClasses?: string;
	shouldShowIndicator?: boolean;
	customClassName?: string;
}) {
	const buttonClasses = classnames(
		props.customClassName || "tabs__toggle btn btn--square btn--square--sml",
		props.buttonClasses
	);
	const iconClasses = classnames(
		"btn__icon u-icon u-icon--sml",
		props.iconClasses
	);

	return (
		<button
			type="button"
			onClick={() => props.setIsOpen(!props.isOpen)}
			className={buttonClasses}
		>
			{props.shouldShowIndicator && (
				<span className="tabs__toggle__indicator" />
			)}
			<i className={iconClasses} />
		</button>
	);
}
